/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailPayments_user" | "PdpSharedDetailShipping_user" | "PdpSharedDetailItemInvoice_user">;
    readonly " $refType": "PdpRespShippingReturns_user";
};
export type PdpRespShippingReturns_user$data = PdpRespShippingReturns_user;
export type PdpRespShippingReturns_user$key = {
    readonly " $data"?: PdpRespShippingReturns_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailPayments_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailItemInvoice_user",
      "args": null
    }
  ]
};
(node as any).hash = '5254f0603acaa85f2ce928fe52c22f2d';
export default node;
